import React from 'react';
import { Text, Box } from '@wix/design-system';
import { useAtomValue } from 'jotai';
import { isThemeLoadingAtom } from '../../atoms';
import { useSelectedThemeColor, useSetSelectedThemeColor } from '../../../../store/appStore';
import cs from 'classnames';
import s from './MobileTemplateGrid.scss';
import { THEME_KEYS_TRANSLATIONS } from '@common/constants/themes';
import { templateColors } from '../../types';

interface TemplateGridProps {
  isDisabled?: boolean;
}

export function MobileTemplateGrid({ isDisabled = false }: TemplateGridProps) {
  const selectedThemeColor = useSelectedThemeColor();
  const isLoading = useAtomValue(isThemeLoadingAtom);
  const setSelectedThemeColor = useSetSelectedThemeColor();
  const isInteractionDisabled = isDisabled || isLoading;

  return (
    <Box className={s.tempalteContainer} direction="vertical" gap={2}>
      {templateColors.map((template) => (
        <div
          key={template.name}
          className={cs(s.templateCard, {
            [s.selected]: selectedThemeColor === template.name,
            [s.disabled]: isInteractionDisabled,
          })}
          onClick={() => !isInteractionDisabled && setSelectedThemeColor(template.name)}
          role="button"
          tabIndex={isInteractionDisabled ? -1 : 0}
          onKeyDown={(e) => {
            if (!isInteractionDisabled && (e.key === 'Enter' || e.key === ' ')) {
              setSelectedThemeColor(template.name);
            }
          }}
        >
          <Box className={s.cardHeader} gap={2}>
            <Text weight="bold" size="small" className={s.templateName}>
              {THEME_KEYS_TRANSLATIONS[template.name]}
            </Text>

            <Box className={s.colorBoxesContainer}>
              {template.colors.map((color, index) => (
                <div key={index} className={s.colorBox} style={{ '--color': color } as React.CSSProperties} />
              ))}
            </Box>
          </Box>

          <Text size="tiny" weight="thin" className={s.templateDescription}>
            {template.description}
          </Text>
        </div>
      ))}
    </Box>
  );
}
